import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import GuideArticlePage from "@/pages/guide/page";
import SafetyArticlePage from "@/pages/safety/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artykul/kakobuy-sheet-poradnik",
    element: <ArticlePage />,
  },
  {
    path: "/poradnik-zakupowy-kakobuy",
    element: <GuideArticlePage />,
  },
  {
    path: "/bezpieczne-zakupy-kakobuy",
    element: <SafetyArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;